import { useEffect, useState } from "react";
import "./index.css";
import { useParent } from "../../../../../APIContext/ParentContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const Package = () => {
  const navigate = useNavigate();
  const { fetchParentPackages } = useParent();
  const [packageData, setPackageData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await fetchParentPackages();
      if (result) {
        setPackageData(result);
      } else {
        navigate("/login");
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <div
        style={{ filter: "brightness(1.28)" }}
        className="profile-content-area bg-custom"
      >
        <div className="profile-detail-container">
          <div className="player-header">
            <h2 className="text-clip">Packages Details</h2>
            <button
              className="add-player-btn"
              onClick={() => navigate("/your-packages")}
            >
              Schedule Your Session
            </button>
          </div>
          <div className="package-table">
            <div className="table-header">
              <span className="text-clip">Package Name</span>
              <span className="text-clip">Price ($)</span>
              <span className="text-clip">Player</span>
              <span className="text-clip">Credits Remaining</span>
              <span className="text-clip">Session Type</span>
              <span className="text-clip">Package Status</span>
            </div>

            {packageData.length > 0 ? (
              packageData.map((item, index) => (
                <div className="table-row" key={index}>
                  <span className="text-clip" data-label="Order ID">
                    {item.package?.name}
                  </span>
                  <span className="text-clip" data-label="Subscribed Package">
                    {item.package?.price}
                  </span>
                  <span className="text-clip" data-label="Credits Remaining">
                    {item.player?.name}
                  </span>
                  <span
                    className="text-clip"
                    data-label="Next Bill (YYYY-MM-DD)"
                  >
                    {item.is_unlimited === true
                      ? "Unlimited"
                      : item.remaining_sessions}
                  </span>
                  <span className="text-clip" data-label="Package Status">
                    {item.package?.is_group_session === true
                      ? "Group"
                      : "Individual"}
                  </span>
                  <span className="text-clip" data-label="Subscription">
                    {item.status}
                  </span>
                </div>
              ))
            ) : (
              <div className="no-package">No Packages Available</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Package;
